import Mario from './mario/Mario'
import './App.css';

function App() {
  return (
    <div className="App">
     <Mario/>
    </div>
  );
}

export default App;
